import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Button
} from "@mui/material";

function LoadingModal({
  open,
  close,
  onClose,
  message = "Processing...",
  message2 = "",
  message3 = ""
}) {
  return (
    <Modal
      open={open || close}
      aria-labelledby="loading-modal"
      aria-describedby="loading-spinner"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Box
        sx={{
          position: "relative", // ✅ needed for top-right button
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          minWidth: 300
        }}
      >
        {/* ✅ OK button (only when close=true) */}
        {close && (
          <Button
            size="small"
            variant="contained"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 12,
              right: 12
            }}
          >
            OK
          </Button>
        )}

        {!close && <CircularProgress />}

        <Typography>{message}</Typography>
        {message2 && <Typography>{message2}</Typography>}
        {message3 && <Typography>{message3}</Typography>}
      </Box>
    </Modal>
  );
}

export default LoadingModal;
